import React from "react";
import styles from "./details.module.scss";

const Details = ({ heading, data, description, MyRef }) => {
  return (
    <div className={styles.container} ref={MyRef}>
      <div className={styles.wrapper}>
        <div className={styles.heading}>{heading}</div>
        <div className={styles.data}>{data}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default Details;
